import { generateUuid } from '../../util/generateUuid';
import AutoReplySuppressedMessage from '../records/AutoReplySuppressedMessage';
export const buildAutoReplySuppressedMessage = (props = {}) => {
  const id = props.id || generateUuid();
  return new AutoReplySuppressedMessage(Object.assign({}, props, {
    id
  }));
};